import React from "react";
import { createRoot } from "react-dom/client";
import SignalPath from "./SignalPath.jsx";
import "./index.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <SignalPath />
  </React.StrictMode>
);
